

import * as config from "./config";
import { ajax } from "./helpers";


export const state = {
    recipe: {},
    search: {
        query: "",
        recipes: [],
        page: config.STARTING_RESULTS_PAGE,
        resultsPerPage: config.RESULTS_PER_PAGE
    },
    bookmarks: []
}


function createRecipeObject(data) {
    return {
        id: data.id,
        title: data.title,
        publisher: data.publisher,
        sourceUrl: data.source_url,
        image: data.image_url,
        servings: data.servings,
        cookingTime: data.cooking_time,
        ingredients: data.ingredients,
        ...(data.key && { key: data.key })
    };
}


export const loadRecipe = async function(id) {
    try {
        
        const response = await ajax(`${config.API_URL}/${id}?key=${config.API_KEY}`);
        const { recipe } = response.data;

        state.recipe = createRecipeObject(recipe);
        state.recipe.bookmarked = doesBookmarkExist();

    } catch(error) { throw error; }
}


export const loadSearchRecipe = async function(query) {
    try {
        const response = await ajax(`${config.API_URL}?search=${query}&key=${config.API_KEY}`);
        const { recipes } = response.data;
        
        state.search.query = query;
        state.search.recipes = recipes.map(recipe => {
            return {
                id: recipe.id,
                title: recipe.title,
                publisher: recipe.publisher,
                image: recipe.image_url,
                ...(recipe.key && { key: recipe.key })
            }
        });
        state.search.page = config.STARTING_RESULTS_PAGE;
    } catch(error) { throw error; }
}


export const getSearchResultsPage = function(page = state.search.page) {
    state.search.page = page;

    const start = (page - 1) * state.search.resultsPerPage;
    const end = page * state.search.resultsPerPage;

    return state.search.recipes.slice(start, end);
}


export const updateServings = function(newServings) {
    state.recipe.ingredients.forEach(ing => {
        ing.quantity = (newServings * ing.quantity) / state.recipe.servings;
    });

    state.recipe.servings = newServings;
}


export const toggleBookmark = function(recipe) {
    if (recipe.id !== state.recipe.id) return;

    const isBookmarked = state.bookmarks.some(rec => rec.id === recipe.id);

    isBookmarked ? removeBookmark(recipe) : addBookmark(recipe);
}


export const uploadRecipe = async function(newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe)
        .filter(entry => entry[0].startsWith("ingredient") && entry[1] !== "")
        .map(ingredient => {
            const ingredientArr = ingredient[1].split(",").map(entry => entry.trim());

            if (ingredientArr.length !== 3) {
                throw new Error("Wrong ingredient format! Please use the correct format in order to proceed.")
            }

            [quantity, unit, description] = ingredientArr;
            
            return {quantity: quantity ? +quantity : null, unit, description};
        });

        const recipe = {
            title: newRecipe.title,
            publisher: newRecipe.publisher,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            servings: newRecipe.servings,
            cooking_time: newRecipe.cookingTime,
            ingredients
        }

        const response = await ajax(`${config.API_URL}?key=${config.API_KEY}`, recipe);
        state.recipe = createRecipeObject(response.data.recipe);
        addBookmark(state.recipe);
    } catch(error) { throw error; }
}

// ======================================
// Module's Helper Functions
// ======================================

function addBookmark(recipe) {
    state.bookmarks.push(recipe);
    state.recipe.bookmarked = true;

    updateLocalStorage();
}


function removeBookmark(recipe) {
    const recipeToRemove = state.bookmarks.findIndex(rec => rec.id === recipe.id);

    state.bookmarks.splice(recipeToRemove, 1);
    state.recipe.bookmarked = false;

    updateLocalStorage();
}


function updateLocalStorage() {
    localStorage.setItem("bookmarks", JSON.stringify(state.bookmarks));   
}


function doesBookmarkExist() {
    return state.bookmarks.some(rec => rec.id === state.recipe.id);
}


function loadBookmarks() {
    const bookmarks = JSON.parse(localStorage.getItem("bookmarks"));
    if (!bookmarks) return;
    state.bookmarks = bookmarks;
}


function init() {
    loadBookmarks();
}


init();